import {
  ITrackMutation,
  ITrackMutationForm,
  TRACK_CENSORIOUS,
} from 'services/tracks/types';
import { unknownEnumValueConverter } from 'utils/global/valueConverter.utils';
import { getArtistsWithRolePlacement } from './artistsWithRolePlacement';

export const trackFormToQuery = (
  trackForm: ITrackMutationForm
): ITrackMutation => {
  const { mp3Link, mp3PreviewLink, wavLink, file, ...track } = {
    ...trackForm,
    source: 1,
    censorious: unknownEnumValueConverter<TRACK_CENSORIOUS>(
      trackForm.censorious
    ),
    genre: unknownEnumValueConverter<number>(trackForm.genre.id),
    artists: getArtistsWithRolePlacement(trackForm.artists),
    isrc: trackForm.isrc?.replaceAll('-', ''),
    cline: trackForm.cline?.name?.length ? trackForm.cline : null,
    pline: trackForm.pline?.name?.length ? trackForm.pline : null,
    contractRequests: trackForm.contracts.map(
      ({ contractId, divisionPercentage, startDate, endDate }) => ({
        contractId,
        divisionPercentage,
        startDate,
        endDate: endDate?.length ? endDate : null,
      })
    ),
  };

  return track;
};
